import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Text } from 'shared/components'
import { auth } from 'routes/route.map'
import { TransitionLink } from 'local/components'

import UserForm from './components/userForm'

import * as styles from './styles'

const SignupComponent = ({ onSubmit }) => (
  <Margin tb={4} resetWhen="phone" css={styles.signupContainer}>
    <section css={styles.signupSection}>
      <Margin as="section" bottom={2}>
        <Text as="h2" size={24} white>
          Join Inwin Sport
        </Text>
      </Margin>
      <section>
        <TransitionLink
          text="Already have an account?"
          linkText="Log in"
          to={auth.login()}
        />
      </section>
      <Margin as="section" tb={2}>
        <UserForm onSubmit={onSubmit} />
      </Margin>
    </section>
  </Margin>
)

SignupComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default SignupComponent
